import { v4 as uuidv4 } from 'uuid'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import { useFetch } from '@flowwai-frontend/shared/common'

import {
   MAP_CENTER_POINT,
   OLA_MAPS_AUTOCOMPLETE_API_KEY,
   RADIUS_IN_METERS
} from '../constants/OlaMapsAutocompleteConstants'
import { MapCoordinates } from '../types'

export const PLACES_BASE_URL = 'https://api.olamaps.io/places/v1/'

interface PredictionType {
   description?: string
   geometry?: {
      location: MapCoordinates | null
   } | null
}

interface ResponseType {
   predictions?: PredictionType[]
   info_messages: []
   error_message: string
   status: ''
}

interface TriggerAPIArgType {
   suggestString: string
   onSuccess: (coOrdinates: MapCoordinates | null) => void
   onFailure?: (errorMessage: string) => void
}

interface HookReturnType {
   triggerAPI: (arg: TriggerAPIArgType) => void
   apiStatus: APIStatus
   apiError: Error | null
}

const useOLAMapStringSearch = (): HookReturnType => {
   const fetchAPI = useFetch()
   const { triggerAPI, ...rest } = fetchAPI

   const searchOlaMap = (arg: TriggerAPIArgType): void => {
      const queryParams: Record<string, string> = {
         input: arg.suggestString,
         location: `${MAP_CENTER_POINT.latitude},${MAP_CENTER_POINT.longitude}`,
         radius: RADIUS_IN_METERS.toString(), // Ensure radius is a string
         api_key: OLA_MAPS_AUTOCOMPLETE_API_KEY
      }

      const urlSearchParams = new URLSearchParams(queryParams)

      const fetchUrl = `${PLACES_BASE_URL}autocomplete?${urlSearchParams.toString()}`

      fetchAPI.triggerAPI({
         fetchUrl,
         requestHeader: {
            'X-Request-Id': uuidv4()
         },
         method: 'GET',
         onSuccess: (data: unknown) => {
            const isResponseExists =
               typeof data === 'object' &&
               data !== null &&
               Array.isArray((data as ResponseType).predictions) &&
               (data as ResponseType).predictions!.length > 0

            if (isResponseExists) {
               const firstPrediction: PredictionType = (data as ResponseType)
                  .predictions![0]

               const coOrdinates = firstPrediction.geometry?.location || null
               arg.onSuccess(coOrdinates)
            }
         },
         onFailure: (errorMessage: string) => {
            console.error(errorMessage)
         }
      })
   }

   return { triggerAPI: searchOlaMap, ...rest }
}

export default useOLAMapStringSearch
